import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppUpdateMessage',
  setup(__props) {

const refreshing = ref(false)
const registration = ref<ServiceWorkerRegistration | null>(null)
const showUpdate = ref(false)

function showRefreshUI(e: Event) {
	registration.value = (e as CustomEvent<ServiceWorkerRegistration>).detail
	showUpdate.value = true
}

function refreshApp() {
	showUpdate.value = false
	if (!registration.value || !registration.value.waiting) return
	registration.value.waiting.postMessage('skipWaiting')
}

document.addEventListener(
	'swUpdated', showRefreshUI, { once: true },
)
navigator.serviceWorker.addEventListener(
	'controllerchange', () => {
		if (refreshing.value) return
		refreshing.value = true
		window.location.reload()
	},
)

return { __sfc: true,refreshing, registration, showUpdate, showRefreshUI, refreshApp }
}

})